// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__37tgT","right":"Footer_right__3H_Z5","buttons":"Footer_buttons__1pM9B"};